const appConfig = {
    // Kept in sync with VITE_API_BASE_URL (see redux/constants) so the
    // axios-based services (ApiService/BaseService) hit the same backend as
    // the fetch-based ones instead of a relative, same-origin '/api'.
    apiPrefix: import.meta.env.VITE_API_BASE_URL || 'http://paymentcollectapi.mwetanacloud.com/api/',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    // Was `true` -- combined with the commented-out guard in App.js, this
    // meant the mock API server ran unconditionally in every environment,
    // including production. Both are fixed together as part of increment 3.
    enableMock: false
}

export default appConfig